import React, { useMemo } from 'react';
import DataTable from 'react-data-table-component';
import { ApiGeneralItem, BasicTab } from '../config/type';
import { buildColumns } from '../utils/buildColumns';



type Props = {
  rows: ApiGeneralItem[];
  tab: BasicTab;
  onRowClick?: (row: ApiGeneralItem) => void; // ⬅️ nuovo
  onSortChange?: (field: string, direction: 'asc' | 'desc') => void;
};

export default function GeneralTable({ rows, tab, onRowClick, onSortChange }: Props) {
  const columns = useMemo(() => buildColumns(tab), [tab]);

  return (
    <div className="table-responsive">
      <DataTable<ApiGeneralItem>
        data={rows}
        columns={columns}
        pagination
        striped
        paginationPerPage={50}
        highlightOnHover
        onRowClicked={onRowClick}
        dense
        noDataComponent="Nessun dato disponibile"
        onSort={(column: any, sortDirection) => {
          const field =
            column?.sortField ??
            (typeof column?.selector === 'string' ? column.selector : undefined);
          if (field && onSortChange) onSortChange(field, sortDirection as 'asc' | 'desc');
        }}
      />
    </div>
  );
}

